<template>
    <div style="display: inline-block; text-align: left;">
        <div :id="uid" class="modal bottom-sheet" style="left: 0">
            <div class="modal-header">
                <a class="modal-close waves-effect waves-green btn-flat"><span class="material-icons">close</span></a>
                <h6>{{item.number}}</h6>
            </div>
            <div class="modal-content">
                <div v-if="loaded" >
                    <devicegraph :properties="properties" :color="'red'" />
                    <template v-for="property in properties">
                        <template v-if="property.property_id != null">
                            <div>
                                <p>{{property.date | formatDate}}</p>
                                <p>Kontrola:
                                {{long_act_levels[property.conditions]}}</p>
                                <p v-if="property.conditions > 0">
                                    Szkodniki: {{(property.pests || [] ).join(", ")}}
                                </p>
                                {{safety_conditions_list[property.safety_conditions]}}
                            </div>
                        </template>
                         <template v-if="property.problem_id != null">
                            <div>
                                {{property.date | formatDate}}
                                <p>Zgłoszony problem: {{problem_kinds[property.kind]}}</p>
                            </div>
                        </template>
                    </template>
                </div>
                <preloader v-if="!loaded" />
            </div>
        </div>
        <div :data-target="uid" class="modal-trigger" v-on:click="load_device()">{{item.number}}</div>
    </div>
</template> 
<script>
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
export default {
    data: function() {
        return {
            uid: _.uniqueId("deviceinfopopup"),
            loaded: false,
            properties: [],
            act_levels: [this.$t('devices.no_activity_short'), this.$t('devices.low_activity_short'), this.$t('devices.average_activity_short'), this.$t('devices.high_activity_short'), this.$t('devices.very_high_activity_short')],
            long_act_levels: [this.$t('devices.no_activity'), this.$t('devices.low_activity'), this.$t('devices.average_activity'), this.$t('devices.high_activity'), this.$t('devices.very_high_activity')],
            problem_kinds: ["", this.$t('inspection.not_found'), this.$t('inspection.unreadable_code'), this.$t('inspection.unavailable'), this.$t('inspection.need_remove'), this.$t('inspection.destroyed'), this.$t('inspection.temporary_disabled')],
            safety_conditions_list: ["", this.$t('inspection.safety_conditions_broken'), this.$t('inspection.safety_conditions_need_replace'), this.$t('inspection.safety_conditions_good')]
        }
    },
    mounted: function() {
        var elemss = this.$el.querySelectorAll('.modal');
        this.instance = M.Modal.init(elemss, {
            onOpenStart: () => {
            }
        });
    },
    created: function() {

    },
    methods: {
        load_device: async function() {
            console.log(this.item);
            var a = moment(this.item.real_time).subtract(12, 'months')
            var b = moment(this.item.real_time).add(1, 'day')
            var response = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/devices/' + this.item.device_id + '/properties/'+a.unix()+'/'+b.unix()+'.json');
            this.loaded = true;
            this.properties = _.sortBy(response.data, 'date')
        }
    },
    props: { 
        item: Object,
        place_id: Number,
        customer_id: Number
    },
    computed: {

    },

}
</script>
<style scoped>
div {
    margin-left: auto;
    left: auto;
    right: auto;
    line-height: 2;
}
.modal-header {
    position: sticky;
    top: 0;
    background-color: white;
}
h6 {
    padding-left: 32px;
}
/deep/ #line-chart{
    height: 200px;
}
.modal-trigger {
    text-decoration: underline dashed;
}
</style>